import React, { useState } from "react";
import ProjectResultCardComponent from "../../../Components/card/projectResultCard";
import { getUserData } from "../../../Utils/localStorageUtils";
import { useToast } from "../../../hooks/useToast";
import { addInterestedUserinProrject } from "../../../services/projectService";

const DatalistSection = ({ projectesData }) => {
    const [loadingProjectId, setLoadingProjectId] = useState(null); // Track loading per project
    const [connectedProjects, setConnectedProjects] = useState([]); // Track successfully connected projects

    const userData = getUserData();
    const { showSuccess, showError } = useToast();

    const handleContactBuilder = async (projectId) => {
        if (connectedProjects.includes(projectId)) return; // If already connected, do nothing

        setLoadingProjectId(projectId); // Set loading state for this project

        try {
            const response = await addInterestedUserinProrject(userData?._id, projectId);
            if (response.success) {
                showSuccess(response?.message || "Successfully connected with the builder!");
                setConnectedProjects((prev) => [...prev, projectId]); // Mark as connected
            } else {
                showError(response.message || "Failed to connect.");
            }
        } catch (error) {
            showError("Something went wrong, please try again.");
        }

        setLoadingProjectId(null); // Reset loading state
    };

    return (
        <div className="flex flex-col gap-4">
            {projectesData.length > 0 ? (
                projectesData.map((projectData, index) => (
                    <ProjectResultCardComponent
                        key={index}
                        projectData={projectData}
                        onContactBuilder={handleContactBuilder} // Pass function as prop
                        loading={loadingProjectId === projectData._id} // Track loading state
                        connected={connectedProjects.includes(projectData._id)} // Check if already connected
                    />
                ))
            ) : (
                <p>No projects available.</p>
            )}
        </div>
    );
};

export default DatalistSection;
